import React from 'react';

import { Grid, Paper } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { StyledTypography, StyledButton, FlexContainer } from 'styles/common';

import { REVIEW_EVENTS1, sendReviewEvents } from 'constants/mixpanelHelper';
import { routesForTracking } from 'constants/routesForTracking';

import { showNominatePeers } from 'services/nominatePeers';

const StyledErrorOutlineIcon = styled(ErrorOutlineIcon)`
  margin: 0 1.25 rem 0 0;
`;

const StyledGrid = styled(Grid)`
  padding: 1rem 0 1rem 0.5rem;
`;

const StyledPaper = styled(Paper)`
  margin: 0 1.5rem 0;
  box-shadow: none;
  border-bottom: 1px solid #eaeaea;
  border-radius: 0;
`;

const PeerAlertRowDisplay = ({ message, feedbackForm }) => {
  const dispatch = useDispatch();

  const handleNominateClick = () => {
    sendReviewEvents({
      eventName: REVIEW_EVENTS1.openedNominateSidePanel,
      page: {
        pageName: routesForTracking.reviewLandingPage.pageName,
        flow: 'Activity',
      },
      referrer: 'ActiveReviews',
    });

    dispatch(showNominatePeers({ reviewId: feedbackForm.id }));
  };

  return (
    <StyledPaper>
      <StyledGrid container>
        <Grid container item xs={10} alignItems="center">
          <FlexContainer style={{ alignItems: 'center' }}>
            <StyledErrorOutlineIcon color="error" />
            <StyledTypography leftGutter={2} rightGutter={2} variant="body1">
              {message}
            </StyledTypography>
          </FlexContainer>
        </Grid>
        <Grid container item xs={2} alignItems="center">
          <StyledButton size="large" fullWidth variant="outlined" borderColor="#f44336" onClick={handleNominateClick}>
            <StyledTypography variant="body1" color="#f44336" clickable>
              Nominate
            </StyledTypography>
          </StyledButton>
        </Grid>
      </StyledGrid>
    </StyledPaper>
  );
};

export default PeerAlertRowDisplay;
